// extracted by mini-css-extract-plugin
export default {"AddToCallingPipelineBtn":"add-to-calling_AddToCallingPipelineBtn__ozyXW"};